import React, { useState, useContext, useEffect, useMemo } from "react";
import Button from "./Button";
import Header from "./Header";
import loadingGif from "../img/loading.gif";

import { AppContext } from "../context";
import {
    setLog,
    userLogs,
    patLogs,
    setResumeFlowEmail,
    translateText,
    makeRequest,
    setKotakVehicleDataFlag,
    setKotakVehicleData
} from "../context/utils";
import Navbar from "./Navbar";

let logsbugs = true;

const CITY_TIERS = ["Tier 1", "Tier 2", "Tier 3", "Tier 4", "Tier 5"];

// Clients that type a free-text city name instead of picking a city tier.
// To switch another client over, add its client id here — or set
// config["intro-page"]["city_name_input"] to true in that client's config
// to do it without a code change. Either one turns the field into a text
// input, and the value is then submitted as `cityName` (stored in the
// city_name column) instead of `cityTier` (stored in city_tier).
const CITY_NAME_INPUT_CLIENTS = ["client_1422_claim"];

const KotakFormPage = () => {
    const {
        setScreen,
        clientId,
        token,
        inspectionId,
        config,
        showAlert,
        setCurrentPage,
        currentPage,
        setStartPing,
    } = useContext(AppContext);

    const useCityNameInput =
        config["intro-page"]?.["city_name_input"] === true ||
        CITY_NAME_INPUT_CLIENTS.includes(clientId);

    const land = () => window.innerWidth > window.innerHeight * 1.2;

    const [screenHeight, setScreenHeight] = useState(land() ? false : true);
    const [formData, setFormData] = useState({
        registrationYear: "",
        // Holds whichever the client's form shows — a city tier or a city
        // name. onProceed submits it under the matching key so each lands in
        // its own DB column.
        city: "",
        make: "",
        model: "",
        variant: ""
    });
    const [vehicleInfo, setVehicleInfo] = useState({});

    logsbugs = false;

    const validationRules = {
        make: (v) => v !== "",
        model: (v) => v !== "",
        variant: (v) => v !== "",
        registrationYear: (v) => v !== "",
        city: (v) => v.trim() !== ""
    };

    window.onresize = () => {
        setScreenHeight(land() ? false : true);
    };

    const getTranslateText = (text) => {
        if (Object.keys(config["language"]).includes(text)) {
            return config["language"][text];
        } else {
            // const data = translateText(text, config["language"]["langCode"]);
            return text;
        }
    };

    const switchLandscape = () => {
        let isAndroid = /Android/.test(navigator.userAgent) || false;
        if (isAndroid) {
            const element = document.documentElement;
            if (element.requestFullscreen) {
                element
                    .requestFullscreen()
                    .then(() => {
                        if (
                            Object.keys(config).includes("allowPortraitApp") &&
                            screen.orientation &&
                            screen.orientation.lock
                        ) {
                            screen.orientation
                                .lock("portrait")
                                .then(function success() {
                                    setScreen("menu");
                                    //patLogs("switch to landscape", inspectionId);
                                })
                                .catch(function error(e) {
                                    // console.log(e.message);
                                    setScreen("menu");
                                });
                        } else if (
                            Object.keys(config).includes("allowPortraitApp") &&
                            window.screen &&
                            window.screen.orientation &&
                            window.screen.orientation.lock
                        ) {
                            window.screen.orientation
                                .lock("portrait")
                                .then(function success() {
                                    setScreen("menu");
                                    //patLogs("switch to landscape", inspectionId);
                                })
                                .catch(function error(e) {
                                    // console.log(e.message);
                                    setScreen("menu");
                                });
                        } else if (screen.orientation && screen.orientation.lock) {
                            screen.orientation
                                .lock("landscape")
                                .then(function success() {
                                    setAutoRotate(true);
                                    setScreen("menu");
                                    //patLogs("switch to landscape", inspectionId);
                                })
                                .catch(function error(e) {
                                    // console.log(e.message);
                                    setScreen("menu");
                                });
                        } else if (
                            window.screen &&
                            window.screen.orientation &&
                            window.screen.orientation.lock
                        ) {
                            window.screen.orientation
                                .lock("landscape")
                                .then(function success() {
                                    setScreen("menu");
                                    //patLogs("switch to landscape", inspectionId);
                                })
                                .catch(function error(e) {
                                    // console.log(e.message);
                                    setScreen("menu");
                                });
                        } else {
                            setScreen("menu");
                        }
                    })
                    .catch((error) => {
                        // console.log("Failed to enter fullscreen mode:", error);
                        if (Object.keys(config).includes("directModule")) {
                            setAutoRotate(true);
                        }
                        setScreen("menu");
                    });
            } else {
                setScreen("menu");
            }
        } else {
            setScreen("menu");
        }
    };

    const handleInputChange = (key, value) => {
        if (key === "make") {
            setFormData({
                ...formData,
                make: value,
                model: "",
                variant: ""
            });
            return;
        }
        if (key === "model") {
            setFormData({
                ...formData,
                model: value,
                variant: ""
            });
            return;
        }
        setFormData({
            ...formData,
            [key]: value
        });
    };

    const onProceed = () => {
        const { city, ...vehicleData } = formData;
        // Send only the field the user actually filled in, so the backend can
        // write it to the matching column (city_name vs city_tier).
        const payload = {
            ...vehicleData,
            ...(useCityNameInput
                ? { cityName: city.trim() }
                : { cityTier: city })
        };

        setLog(`kotak new form page was completed`);
        patLogs("Kotak Form page is completed", inspectionId);
        setKotakVehicleDataFlag(true);
        setKotakVehicleData(payload);
        switchLandscape();
    };

    const extractVehicleData = async () => {
        const asyncVehicleData = await makeRequest("/vehicleInformation");
        const data = await asyncVehicleData.json();
        setVehicleInfo(data);
    }

    const generateYears = () => {
        const years = [];
        const current = new Date().getFullYear();

        for (let i = current; i >= 1990; i--) {
            years.push(i);
        }

        return years;
    };

    useEffect(() => {
        patLogs("Entered to kotal new form page", inspectionId);
        userLogs({
            position: 8,
            last_page: "kotak form page",
            inspectionId: inspectionId,
        });
        extractVehicleData();
    }, []);

    const isFormValid = useMemo(() => {
        // console.log("formDFata data::: ", formData)
        return Object.keys(validationRules).every((key) =>
            validationRules[key](formData[key])
        );
    }, [formData]);

    return (
        <div
            className="screen_email"
            style={{
                height: screenHeight ? "100dvh" : "",
                position: screenHeight ? "relative" : "",
                padding: screenHeight ? "0%" : "",
            }}
        >
            <Navbar />
            <h1
                style={{ width: "93%", textAlign: "center", margin: "0px", paddingTop: "10%", paddingBottom: "5%" }}
            >
                {config["intro-page"]["kotak-from-header"] ? config["intro-page"]["kotak-from-header"] : getTranslateText("Vehicle Information")}
            </h1>
            <div className="HyundaiVInDIv">
                <div style={{ display: "flex", flexDirection: "column", width: "95%", padding: "1% 1% 1% 1%", gap: "3%" }}>
                    {/* MAKE */}
                    <div>
                        <label style={{ fontSize: "14px", fontWeight: "600", padding: "0% 0% 1% 0%", margin: "0px" }}>{getTranslateText("Make")}</label>
                        <select
                            value={formData.make}
                            onChange={(e) =>
                                handleInputChange("make", e.target.value)
                            }
                            style={{ width: "100%", height: "42px", borderRadius: "6px", border: "1px solid #d1d5db", padding: "8px", fontSize: "14px", background: "#fff" }}
                        >

                            <option value="">{getTranslateText("Select Make")}</option>
                            {Object.keys(vehicleInfo).map((make) => (
                                <option key={make} value={make}>
                                    {make}
                                </option>
                            ))}

                        </select>
                    </div>

                    {/* MODEL */}
                    <div>
                        <label style={{ fontSize: "14px", fontWeight: "600", padding: "0% 0% 1% 0%", margin: "0px" }}>{getTranslateText("Model")}</label>
                        <select
                            value={formData.model}
                            disabled={!formData.make}
                            onChange={(e) =>
                                handleInputChange("model", e.target.value)
                            }
                            style={{
                                ...{ width: "100%", height: "42px", borderRadius: "6px", border: "1px solid #d1d5db", padding: "8px", fontSize: "14px" },
                                background: !formData.make ? "#f3f4f6" : "#fff"
                            }}
                        >

                            <option value="">{getTranslateText("Select Model")}</option>

                            {formData.make &&
                                Object.keys(vehicleInfo[formData.make]).map((model) => (
                                    <option key={model} value={model}>
                                        {model}
                                    </option>
                                ))}

                        </select>
                    </div>

                    {/* VARIANT */}
                    <div>
                        <label style={{ fontSize: "14px", fontWeight: "600", padding: "0% 0% 1% 0%", margin: "0px" }}>{getTranslateText("Variant")}</label>

                        <select
                            value={formData.variant}
                            disabled={!formData.model}
                            onChange={(e) =>
                                handleInputChange("variant", e.target.value)
                            }
                            style={{
                                ...{ width: "100%", height: "42px", borderRadius: "6px", border: "1px solid #d1d5db", padding: "8px", fontSize: "14px" },
                                background: !formData.model ? "#f3f4f6" : "#fff"
                            }}
                        >

                            <option value="">{getTranslateText("Select Variant")}</option>

                            {vehicleInfo[formData.make]?.[formData.model]?.map((variant) => (
                                <option key={variant} value={variant}>
                                    {variant}
                                </option>
                            ))}

                        </select>
                    </div>

                    {/* REGISTRATION YEAR */}
                    <div>
                        <label style={{ fontSize: "14px", fontWeight: "600", padding: "0% 0% 1% 0%", margin: "0px" }}>{getTranslateText("Registration Year")}</label>
                        <select
                            value={formData.registrationYear}
                            onChange={(e) =>
                                handleInputChange("registrationYear", e.target.value)
                            }
                            style={{ width: "100%", height: "42px", borderRadius: "6px", border: "1px solid #d1d5db", padding: "8px", fontSize: "14px", background: "#fff" }}
                        >

                            <option value="">{getTranslateText("Select Registration Year")}</option>

                            {generateYears().map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}

                        </select>
                    </div>

                    {/* CITY TIER (city name text input for CITY_NAME_INPUT_CLIENTS) */}
                    <div>
                        <label style={{ fontSize: "14px", fontWeight: "600", padding: "0% 0% 1% 0%", margin: "0px" }}>
                            {useCityNameInput
                                ? (config["intro-page"]["city_name_label"] ? config["intro-page"]["city_name_label"] : getTranslateText("City Name"))
                                : getTranslateText("City Tier")}
                        </label>
                        {useCityNameInput ? (
                            <input
                                type="text"
                                value={formData.city}
                                onChange={(e) =>
                                    handleInputChange("city", e.target.value)
                                }
                                placeholder={config["intro-page"]["city_name_placeholder"] ? config["intro-page"]["city_name_placeholder"] : getTranslateText("Enter City Name")}
                                style={{ width: "100%", height: "42px", borderRadius: "6px", border: "1px solid #d1d5db", padding: "8px", fontSize: "14px", background: "#fff", boxSizing: "border-box" }}
                            />
                        ) : (
                            <select
                                value={formData.city}
                                onChange={(e) =>
                                    handleInputChange("city", e.target.value)
                                }
                                style={{ width: "100%", height: "42px", borderRadius: "6px", border: "1px solid #d1d5db", padding: "8px", fontSize: "14px", background: "#fff" }}
                            >

                                <option value="">{getTranslateText("Select City Tier")}</option>

                                {CITY_TIERS.map((tier) => (
                                    <option key={tier} value={tier}>
                                        {tier}
                                    </option>
                                ))}

                            </select>
                        )}
                    </div>

                </div>
                <div className="vinButtonHyundaicanada">
                    <Button
                        disabled={!isFormValid}
                        wide={true}
                        onclick={() => isFormValid && onProceed()}
                        text={getTranslateText("Proceed")}
                    />
                </div>
            </div>
        </div>
    );
};

export default KotakFormPage;
